interface Tab {
  key: string;
  label: string;
}

interface TabSwitcherProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (key: string) => void;
}

export default function TabSwitcher({ tabs, activeTab, onTabChange }: TabSwitcherProps) {
  return (
    <div className="inline-flex bg-background-100 rounded-full p-1">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
            activeTab === tab.key
              ? 'bg-background-50 text-foreground-950'
              : 'text-foreground-600 hover:text-foreground-900'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}